import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { VivaInsightsReportDataset } from 'app/model/dataset/viva-insights-report.dataset';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';

// A report is addressed by `reportId`, so the dataset's tableName serialises onto that key.
const reportIdKeyword = 'reportId';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(VivaInsightsReportDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                reportId: '*'
            }
        }
    }
})
export class VivaInsightsReportDatasetAdapter extends TabularTypeDatasetAdapter<VivaInsightsReportDataset, Model.DatasetResource> {
    protected async _toResource(dataset: VivaInsightsReportDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(VivaInsightsReportDataset).name, reportIdKeyword);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: VivaInsightsReportDataset): Promise<VivaInsightsReportDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, VivaInsightsReportDataset.MODEL, reportIdKeyword);
    }
}
